import { TranslationObject } from '../i18n/translation';

const namespace = 'rightsandprivacy';

const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: 'Personvernserklæring',
    en: 'Privacy policy',
  },
  pageTitleStudent: {
    id: `${namespace}.pagetitle.Student`,
    nb: 'Personvernserklæring, Student',
    en: 'Privacy policy, students',
  },
  pageTitleStudiested: {
    id: `${namespace}.pagetitle.Studiested`,
    nb: 'Personvernserklæring, Studiested',
    en: 'Privacy policy, educational institutions',
  },
  pageTitlePraksissted: {
    id: `${namespace}.pagetitle.Praksissted`,
    nb: 'Personvernserklæring, Praksissted',
    en: 'Privacy policy, work placement organization',
  },
  descriptionStudiested: {
    id: `${namespace}.descriptionStudiested`,
    nb: '<em>Personvernserklæring</em> for deg som ansatt ved <em>studiested</em>',
    en: '<em>Privacy policy</em> for employees at <em>educational institutions</em>',
  },
  descriptionStudent: {
    id: `${namespace}.descriptionStudent`,
    nb: '<em>Rettigheter</em> og <em>personvernserklæring</em> for deg som <em>student</em> i høyere utdanning',
    en: '<em>Rights and privacy policy</em> for <em>students</em> in higher education',
  },
  descriptionPraksissted: {
    id: `${namespace}.descriptionPraksissted`,
    nb: '<em>Personvernerklæring</em> for deg som ansatt på <em>praksissted</em>',
    en: '<em>Privacy policy</em> for employees at <em>work placement organization</em>',
  },
  arbeidslivsportalen: {
    id: `${namespace}.arbeidslivsportalen`,
    nb: 'Arbeidslivsportalen',
    en: 'Arbeidslivsportalen',
  },
};

export default translations;
